<template>
    <div class="scroll-y-auto">
      <draggable v-model="editorsComputed" animation="200" ghostClass="ghost" handle=".handle">
        <EditorComponent :editable="editable" v-for="(_, index) in editorsComputed" v-model="editorsComputed[index]" :key="index"
                         @edit="(edit) => onEdit(edit, index)" @delete="deleteEditor(index)"/>
      </draggable>
      <div v-if="editable" class="pt-1 pb-2 text-center">
        <ButtonTertiaryAction @click="addField"/>
      </div>
    </div>
</template>

<script>
import EditorComponent from "@/components/form/EditorComponent";
import {computed} from "@vue/composition-api";
import draggable from 'vuedraggable'
import ButtonTertiaryAction from "@/components/buttons/ButtonTertiaryAction";

export default {
  name: "EditorCardComponent",
  props: {
    value: Array,
    editable: {
      type: Boolean,
      default: true
    }
  },
  components: {ButtonTertiaryAction, EditorComponent, draggable},
  setup(props, {emit}) {
    const editorsComputed = computed({
      get: () => props.value,
      set: (value) => {
        emit('input', value)
      }
    })

    function onEdit(edit, index) {
      let editorsTemp = editorsComputed.value
      editorsTemp[index].edit = edit
      editorsComputed.value = editorsTemp
    }

    function addField() {
      const newEditor = {
        inputValue: '',
        type: '',
        fieldName: '',
        edit: true
      }
      let editorsTemp = editorsComputed.value
      editorsTemp.push(newEditor)
      editorsComputed.value = editorsTemp
    }

    function deleteEditor(index){
      let editorsTemp = editorsComputed.value
      editorsTemp.splice(index, 1)
      editorsComputed.value = editorsTemp
    }

    return {editorsComputed, onEdit, addField, deleteEditor}
  }
}
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.scroll-y-auto {
  overflow-y: auto;
}
</style>
